import React from "react";
import PropTypes from "prop-types";
import AsyncAutoComplete from "components/AsyncAutoComplete";
import loadABSCollateralService from "services/common/loadBenchmarkService";

function SelectBenchmark({
  onSelect,
  disabled,
  error,
  placeholder,
  value,
  filter,
  readOnly,
  params
}) {
  return (
    <AsyncAutoComplete
      promiseFn={loadABSCollateralService}
      params={params}
      onSelect={onSelect}
      textPath="long_name"
      labelPath="benchmark_id"
      idPath="benchmark_id"
      disabled={disabled}
      error={error}
      intent={!!error ? "danger" : null}
      placeholder={placeholder}
      value={value}
      filter={filter}
      readOnly={readOnly}
    />
  );
}

SelectBenchmark.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  initialValue: PropTypes.object,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  filter: PropTypes.func,
  params: PropTypes.object
};

SelectBenchmark.defaultProps = {
  value: undefined,
  disabled: false,
  error: null,
  initialValue: {},
  placeholder: "Search...",
  filter: null,
  params: undefined
};

export default SelectBenchmark;
